import { UseFormSetValue } from 'react-hook-form';
import { CspRegistrationFormData, EmailField } from './types';

export const emailArrayToString = (emailArray: EmailField[]) => {
  return emailArray
    .map((item) => item.email.trim())
    .filter(Boolean)
    .join(',');
};

export const preFillFromToken = (
  setValue: UseFormSetValue<CspRegistrationFormData>
) => {
  const tokenStorage = localStorage.getItem('okta-token-storage');
  if (tokenStorage) {
    try {
      const parsedToken = JSON.parse(tokenStorage);
      const accessToken = parsedToken?.accessToken?.accessToken;
      if (accessToken) {
        const payload = JSON.parse(atob(accessToken.split('.')[1]));
        const { companyName, mobilePhone, sub } = payload;

        if (companyName) {
          setValue('details.companyName', companyName, {
            shouldDirty: true,
          });
          setValue('details.displayName', companyName, {
            shouldDirty: true,
          });
        }
        if (mobilePhone) {
          setValue('contact.phone', mobilePhone, {
            shouldDirty: true,
          });
        }
        if (sub) {
          setValue('contact.email', [{ email: sub }], {
            shouldDirty: true,
          });
        }
      }
    } catch (e) {
      // Silently fail if token is malformed
    }
  }
};

export const syncFromProfile = (
  userProfile: {
    companyName?: string;
    mobilePhone?: string;
    email?: string;
    sub?: string;
  } | null,
  setValue: UseFormSetValue<CspRegistrationFormData>
) => {
  if (userProfile) {
    const { companyName, mobilePhone, email, sub } = userProfile;
    if (companyName) {
      setValue('details.companyName', companyName, {
        shouldDirty: true,
      });
      setValue('details.displayName', companyName, {
        shouldDirty: true,
      });
    }
    if (mobilePhone) {
      setValue('contact.phone', mobilePhone, {
        shouldDirty: true,
      });
    }
    const userEmail = email || sub;
    if (userEmail) {
      setValue('contact.email', [{ email: userEmail }], {
        shouldDirty: true,
      });
    }
  }
};
